import app from '../main'
import * as types from './mutation-types'

export const statelang = {
  lang: 'en'
}

export const mutations = {
  [types.SET_LANG] (state, payload) {
    if (app != null) {
      app.$i18n.locale = payload
    }
  }
}

export const actions = {
  setLang ({ commit }, payload) {
    commit(types.SET_LANG, payload)
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js